import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const CardWrapper = superstyled({
  name: 'ZuiCard',
  slot: 'Root',
  tag: Card,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  }),
});

export const ContentWrapper = superstyled({
  name: 'ZuiContentWrapper',
  slot: 'ContentWrapper',
  tag: CardContent,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    height: '100%',
  }),
});

export const Image = superstyled({
  name: 'ZuiSharedAsset',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    aspectRatio: '17/8',
    objectFit: 'cover',

    [theme.breakpoints.up('md')]: {
      aspectRatio: '87/40',
      height: 'auto',
    },
  }),
});
